module.exports = __webpack_public_path__ + "img/photo_2022-11-09_18-32-31.64f7fe4c.jpg";